<template>
  <gd-modal @closeBG="close" @closeESC="close" @close="close">
    <c-loading-indicator :show="!show" />
    <modal-app l>
      <modal-layout>
        <modal-content>
          <div class="result-modal">
            <c-result-game-info
              :data="store.getters['results/ownRanking']"
              data-qe-id="game-info"
              class="result-game-info"
            />
            <c-result-table
              :data="store.getters['results/rankingTable']"
              :state="GameState.FINISHED"
              data-qe-id="ranking-table"
              :only-game-result="true"
            />
          </div>
          <div>
            <c-customer-service
              @customer="onCustomer"
              :text="$t('resultView.customerService.headline', { competitionId })"
            ></c-customer-service>
          </div>
        </modal-content>
        <modal-actions>
          <t-button @click="close">{{ $t('generic.app.button_modal_close') }}</t-button>
        </modal-actions>
      </modal-layout>
    </modal-app>
  </gd-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import events from '@gd/event-bus'
import { useStore } from '@/store'

import CResultGameInfo from '@/components/CResultGameInfo.vue'
import CResultTable from '@/components/CResultTable.vue'
import { CsFormPreselections, getSubTopic } from '@/lib/customerService'
import GameState from '../model/GameState'
import CCustomerService from '@/components/CCustomerService.vue'

const props = defineProps<{ competitionId: string }>()
const emit = defineEmits(['close'])
const store = useStore()

const show = ref(false)

function created() {
  store
    .dispatch('results/fetchCompetitionResultById', props.competitionId)
    .then(() => {
      // handle progress spinner while loading
      show.value = true
    })
    .catch((err: any) => {
      emit('close')
    })
}
function close() {
  emit('close')
}

function onCustomer() {
  events.$emit('cs-form', {
    topic: 'duelError',
    subTopic: getSubTopic(store.getters['results/zoneId']),
    competitionId: props.competitionId,
  } as CsFormPreselections)
}

created()
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.result-modal {
  .result-game-info {
    margin-top: 0em;
    margin-bottom: 4em;
    .not-win {
      margin-top: 1.5em;
    }
  }
}
</style>
